import { Callout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../connection-manager-next/message-definitions";

import type { MarketingBannerState } from "./marketing-banner-state";

export const MarketingStatusBanner = ({ state }: { state: NonNullable<MarketingBannerState> }) => {
  const intl = useIntl();

  const description =
    state.messageKey === "singlePlatform"
      ? intl.formatMessage(MESSAGES.marketingBannerSinglePlatform, { platformName: state.platformName })
      : intl.formatMessage(MESSAGES.marketingBannerMultiplePlatforms, {
          platformNames: new Intl.ListFormat(intl.locale, { style: "long", type: "conjunction" }).format(
            state.platformNames
          ),
          count: state.count,
        });

  return <Callout variant="info" description={description} />;
};
